import { ContentResizeDirection, ResizeDirection } from '../types';
export const DefaultLayout = {
  resizeDirection: ResizeDirection.horizontalAndVertical,
  contentResizeDirection: ContentResizeDirection.horizontalAndVertical,
  disableStretching: false,
  disablePositioning: false,
  disableRotation: false
};
//# sourceMappingURL=layout.js.map